import './visualizations.scss'
import * as angular from 'angular'

import { MW_VISUALIZATIONS_BASE_MODULE_NAME } from '@meltwater/mw-visualizations-angularjs'
import { SSAnalyticsComponent } from './ss-analytics-component'
import { SSCompareComponent } from './ss-compare-component'
import { SSOverviewComponent } from './ss-overview-component'
import { SSTwitterComponent } from './ss-twitter-component'
import { BaseWidget } from './widget/base/base-widget-component'
import { ContentGridComponent } from './widget/charts/content-grid-component'
import { DonutChartComponent } from './widget/charts/donut-chart-component'
import { DonutChartLoopComponent } from './widget/charts/donut-chart-loop-component'
import { DoubleChartComponent } from './widget/charts/double-chart-component'
import { HorizontalBarChartComponent } from './widget/charts/horizontal-bar-chart-component'
import { LineChartComponent } from './widget/charts/line-chart-component'
import { NumberDeltaComponent } from './widget/charts/number-delta-component'
import { SideDataChartComponent } from './widget/charts/side-data-chart-component'
import { StackedColumnComponent } from './widget/charts/stacked-column-chart-component'
import { TableDataChartComponent } from './widget/charts/table-data-chart-component'
import { VerticalBarChartComponent } from './widget/charts/vertical-bar-chart-component'
import { WordCloudComponent } from './widget/charts/word-cloud-component'
import { WordCloudLoopComponent } from './widget/charts/word-cloud-loop-component'
import { PaginationComponent } from './widget/commons/pagination.component'
import { DynamicChartDirective } from './widget/directives/dynamic-chart-directive'
import { DynamicComponentDirective } from './widget/directives/dynamic-component-directive'
import { AFCompareLatestActivity } from './widget/visualizations/af-compareLatestActivity-component'
import { AFCompareSentiment } from './widget/visualizations/af-compareSentiment-component'
import { AFCompareSovByImpressions } from './widget/visualizations/af-compareSovByImpressions-component'
import { AFCompareSovByImpressionsDonut } from './widget/visualizations/af-compareSovByImpressionsDonut-component'
import { AFCompareSovByImpressionsSpline } from './widget/visualizations/af-compareSovByImpressionsSpline-component'
import { AFCompareSovByLocation } from './widget/visualizations/af-compareSovByLocation-component'
import { AFCompareSovByMentionType } from './widget/visualizations/af-compareSovByMentionType-component'
import { AFCompareSovByMentionTypeDonut } from './widget/visualizations/af-compareSovByMentionTypeDonut-component'
import { AFCompareSovByMentionTypeVert } from './widget/visualizations/af-compareSovByMentionTypeVert-component'
import { AFCompareSovBySource } from './widget/visualizations/af-compareSovBySource-component'
import { AFCompareTopContent } from './widget/visualizations/af-compareTopContent-component'
import { AFCompareWordCloud } from './widget/visualizations/af-compareWordCloud-component'
import { AFEmotionalComparison } from './widget/visualizations/af-emotionalComparison-component'
import { AFEntitiesCloud } from './widget/visualizations/af-entitiesCloud-component'
import { AFLatestActivity } from './widget/visualizations/af-latestActivity-component'
import { AFLatestActivityByMentionType } from './widget/visualizations/af-latestActivityByMentionType-component'
import { AFLatestActivityByMentionTypeDonut } from './widget/visualizations/af-latestActivityByMentionTypeDonut-component'
import { AFLatestActivityByMentionTypeSpline } from './widget/visualizations/af-latestActivityByMentionTypeSpline-component'
import { AFLatestActivityBySource } from './widget/visualizations/af-latestActivityBySource-component'
import { AFMentionsPerDayAverage } from './widget/visualizations/af-mentionsPerDayAverage-component'
import { AFTotalEngagement } from './widget/visualizations/af-totalEngagement-component'
import { AFNegativeWordCloud } from './widget/visualizations/af-negativeWordCloud-component'
import { AFPositiveWordCloud } from './widget/visualizations/af-positiveWordCloud-component'
import { AFSentiment } from './widget/visualizations/af-sentiment-component'
import { AFSentimentBySource } from './widget/visualizations/af-sentimentBySource-component'
import { AFSentimentTrend } from './widget/visualizations/af-sentimentTrend-component'
import { AFSentimentTrendDonut } from './widget/visualizations/af-sentimentTrendDonut-component'
import { AFSentimentTrendSpline } from './widget/visualizations/af-sentimentTrendSpline-component'
import { AFTopLocations } from './widget/visualizations/af-topLocations-component'
import { AFTopEmojis } from './widget/visualizations/af-topEmojis-component'
import { AFTopHashtags } from './widget/visualizations/af-topHashtags-component'
import { AFTopTwitterAuthors } from './widget/visualizations/af-topTwitterAuthors-component'
import { AFTotalMentions } from './widget/visualizations/af-totalMentions-component'
import { AFTwitterAuthorAuthority } from './widget/visualizations/af-twitterAuthorAuthority-component'
import { AFTwitterMetrics } from './widget/visualizations/af-twitterMetrics-component'
import { AFTwitterMetricsData } from './widget/visualizations/af-twitterMetrics-data-component'
import { AFTwitterMetricsSpline } from './widget/visualizations/af-twitterMetrics-spline-component'
import { AFTwitterMostRetweeted } from './widget/visualizations/af-twitterMostRetweeted-component'
import { AFUniqueTwitterAuthors } from './widget/visualizations/af-uniqueTwitterAuthors-component'
import { AFWordCloud } from './widget/visualizations/af-wordCloud-component'
import { AFWordCloudHorizontalBarChart } from './widget/visualizations/af-wordCloud-horizontal-bar-chart-component'
import { SDWordCloud } from './widget/visualizations/sd-wordCloud-component'
import { Widgets } from './widget/widget-error-component'
import { LocationSelectorComponent } from './widget/commons/location-selector.component'
import { ReduxService } from './widget/service/redux.service'
import { AFTopBlogs } from './widget/visualizations/af-topBlogs-component'
import { AFTopSharedLink } from './widget/visualizations/af-topSharedLink-component'
import { AFTopEditorialSources } from './widget/visualizations/af-topEditorialSources-component'
import { AFMostEngagedContent } from './widget/visualizations/af-mostEngagedContent-component'
import { AFTopSubreddits } from './widget/visualizations/af-topSubreddits-component'
import { AFTopForums } from './widget/visualizations/af-topForums-component'
import { AFGenderStacked } from './widget/visualizations/af-genderStacked-component'
import { AFEngagementTrendBySource } from './widget/visualizations/af-engagementTrendBySource-component'

export default angular
 // Modules
 .module('mw.app.social-search-af', [MW_VISUALIZATIONS_BASE_MODULE_NAME])

 // Master Components
 .component(SSOverviewComponent.config.selector, SSOverviewComponent.config)
 .component(SSAnalyticsComponent.config.selector, SSAnalyticsComponent.config)
 .component(SSTwitterComponent.config.selector, SSTwitterComponent.config)
 .component(SSCompareComponent.config.selector, SSCompareComponent.config)

 // Visualization Components
 .component(Widgets.config.selector, Widgets.config)
 .component(AFLatestActivity.config.selector, AFLatestActivity.config)
 .component(AFLatestActivityBySource.config.selector, AFLatestActivityBySource.config)
 .component(AFLatestActivityByMentionType.config.selector, AFLatestActivityByMentionType.config)
 .component(
  AFLatestActivityByMentionTypeSpline.config.selector,
  AFLatestActivityByMentionTypeSpline.config
 )
 .component(
  AFLatestActivityByMentionTypeDonut.config.selector,
  AFLatestActivityByMentionTypeDonut.config
 )
 .component(AFTwitterMetrics.config.selector, AFTwitterMetrics.config)
 .component(AFTwitterMetricsData.config.selector, AFTwitterMetricsData.config)
 .component(AFTwitterMetricsSpline.config.selector, AFTwitterMetricsSpline.config)
 .component(AFSentiment.config.selector, AFSentiment.config)
 .component(AFSentimentTrend.config.selector, AFSentimentTrend.config)
 .component(AFSentimentTrendDonut.config.selector, AFSentimentTrendDonut.config)
 .component(AFSentimentTrendSpline.config.selector, AFSentimentTrendSpline.config)
 .component(AFWordCloud.config.selector, AFWordCloud.config)
 .component(SideDataChartComponent.config.selector, SideDataChartComponent.config)
 .component(AFTopEmojis.config.selector, AFTopEmojis.config)
 .component(AFWordCloudHorizontalBarChart.config.selector, AFWordCloudHorizontalBarChart.config)
 .component(AFTotalMentions.config.selector, AFTotalMentions.config)
 .component(AFMentionsPerDayAverage.config.selector, AFMentionsPerDayAverage.config)
 .component(AFTotalEngagement.config.selector, AFTotalEngagement.config)
 .component(AFUniqueTwitterAuthors.config.selector, AFUniqueTwitterAuthors.config)
 .component(AFEntitiesCloud.config.selector, AFEntitiesCloud.config)
 .component(AFTopHashtags.config.selector, AFTopHashtags.config)
 .component(AFTopLocations.config.selector, AFTopLocations.config)
 .component(AFTopTwitterAuthors.config.selector, AFTopTwitterAuthors.config)
 .component(AFTwitterAuthorAuthority.config.selector, AFTwitterAuthorAuthority.config)
 .component(AFSentimentBySource.config.selector, AFSentimentBySource.config)
 .component(AFEmotionalComparison.config.selector, AFEmotionalComparison.config)
 .component(AFPositiveWordCloud.config.selector, AFPositiveWordCloud.config)
 .component(AFNegativeWordCloud.config.selector, AFNegativeWordCloud.config)
 .component(PaginationComponent.config.selector, PaginationComponent.config)
 .component(BaseWidget.config.selector, BaseWidget.config)
 .component(DoubleChartComponent.config.selector, DoubleChartComponent.config)
 .component(HorizontalBarChartComponent.config.selector, HorizontalBarChartComponent.config)
 .component(DonutChartComponent.config.selector, DonutChartComponent.config)
 .component(LineChartComponent.config.selector, LineChartComponent.config)
 .component(NumberDeltaComponent.config.selector, NumberDeltaComponent.config)
 .component(StackedColumnComponent.config.selector, StackedColumnComponent.config)
 .component(TableDataChartComponent.config.selector, TableDataChartComponent.config)
 .component(VerticalBarChartComponent.config.selector, VerticalBarChartComponent.config)
 .component(WordCloudComponent.config.selector, WordCloudComponent.config)
 .component(WordCloudLoopComponent.config.selector, WordCloudLoopComponent.config)
 .component(DonutChartLoopComponent.config.selector, DonutChartLoopComponent.config)
 .component(SDWordCloud.config.selector, SDWordCloud.config)

 //widgets
 .component(ContentGridComponent.config.selector, ContentGridComponent.config)

 // compare
 .component(AFCompareLatestActivity.config.selector, AFCompareLatestActivity.config)
 .component(AFCompareSentiment.config.selector, AFCompareSentiment.config)
 .component(AFCompareSovByImpressions.config.selector, AFCompareSovByImpressions.config)
 .component(AFCompareSovByImpressionsDonut.config.selector, AFCompareSovByImpressionsDonut.config)
 .component(AFCompareSovByImpressionsSpline.config.selector, AFCompareSovByImpressionsSpline.config)
 .component(AFCompareSovByMentionType.config.selector, AFCompareSovByMentionType.config)
 .component(AFCompareSovByMentionTypeVert.config.selector, AFCompareSovByMentionTypeVert.config)
 .component(AFCompareSovByMentionTypeDonut.config.selector, AFCompareSovByMentionTypeDonut.config)
 .component(AFCompareWordCloud.config.selector, AFCompareWordCloud.config)
 .component(AFCompareSovByLocation.config.selector, AFCompareSovByLocation.config)
 .component(AFCompareSovBySource.config.selector, AFCompareSovBySource.config)
 .component(AFCompareTopContent.config.selector, AFCompareTopContent.config)
 .component(AFTwitterMostRetweeted.config.selector, AFTwitterMostRetweeted.config)
 .component(LocationSelectorComponent.config.selector, LocationSelectorComponent.config)
 .component(AFTopBlogs.config.selector, AFTopBlogs.config)
 .component(AFTopSharedLink.config.selector, AFTopSharedLink.config)
 .component(AFTopEditorialSources.config.selector, AFTopEditorialSources.config)
 .component(AFMostEngagedContent.config.selector, AFMostEngagedContent.config)
 .component(AFTopSubreddits.config.selector, AFTopSubreddits.config)
 .component(AFTopForums.config.selector, AFTopForums.config)
 .component(AFEngagementTrendBySource.config.selector, AFEngagementTrendBySource.config)
 .component(AFGenderStacked.config.selector, AFGenderStacked.config)

 // Directives
 .directive(DynamicComponentDirective.selector, [
  '$compile',
  DynamicComponentDirective.templateService,
 ])
 .directive(DynamicChartDirective.selector, ['$compile', DynamicChartDirective.chartService])
 .service('reduxService', ReduxService)
